
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/government/overview",
      function () {
        return require("private-next-pages/government/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/government/overview"])
      });
    }
  